import { Fragment, useContext, useEffect, useState } from "react";
import React from "react";
import moment from "moment";
import InputField from "../../CommonComponents/InputField";
// import InputDropdown from "../../CommonComponents/InputDropdown";
import Textarea from "../../CommonComponents/Textarea";
// import DragAndDropUpload from "../../CommonComponents/DragAndDropUpload";
import Button from "../../Button";
import AlertContext from "../../../context/AlertContext";
import useAxiosPrivate from "../../../Hooks/useAxiosPrivate";
import constants from "../../../constants";
import { getDataFromStorage, MANAGEMENTROLES } from "../../../util";
import useS3FileManagement from "../../../Hooks/useS3FileManagement";

export const supportedFormat = "zip, jpeg, jpg, png",
  maxChar = 80,
  supportMimeTypes = [
    "application/zip",
    "application/x-zip-compressed",
    "image/png",
    "image/jpg",
    "image/apng",
    "image/jpeg",
  ],
  fields = ["title", "type", "bid", "description"];
export const validate = (name, value) => {
  switch (name) {
    case "title":
      if (!value || value.trim() === "") return "Title is required";
      break;
    case "description":
      if (value && value.length > 1000) return "The maximum character is 1000.";
      if (!value || value.length < 10)
        return "Description must be at least 10 characters long.";
      break;
    default: {
      return "";
    }
  }
};

const ExtentionRequestForm = ({
  initialDetails,
  setShowForm,
  isEdit,
  details,
  lpData,
  contentData,
  setDetails,
  selectedBatch,
  setSelectedBatch,
  selectedType,
  setSelectedType,
  setIsSuccess,
  setExtentPopUp,
  toastOpen,
  setToastOpen,
  SlideTransition,
  toastMessage,
  setToastMessage,
}) => {
  const { setIsLoaded, setShowNotify, isAdmin } = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const { onUploadS3Object } = useS3FileManagement();
  const Alert = useContext(AlertContext);

  const [titleCharCount, setTitleCharCount] = useState(0);
  const [types, setTypes] = useState([]);
  const [batches, setBatches] = useState([]);
  const [errors, setErrors] = useState({});
  const [isRemoved, setIsRemoved] = useState(false);
  const [configid, setConfigId] = useState();

  const isDisabled = !!MANAGEMENTROLES.includes(getDataFromStorage("role"));
  const companyId = isAdmin
    ? getDataFromStorage("companyId")
    : parseInt(localStorage.getItem("companyId"));

  useEffect(() => {
    const fetchBatchesAndTypes = async () => {
      try {
        setIsLoaded(true);
        const response = await axios.get(
          `node/learner/batch?company_id=${companyId}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          },
        );
        const response2 = await axios.get(`node/learner/issue/type?isdoubt=0`, {
          headers: {
            "Content-Type": "application/json",
          },
        });
        if (response2.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          const data = response2.data.data ?? [];
          // console.log("data:", data);
          setTypes(
            data.map((item, index) => ({
              ...item,
              value: item.id,
              label: item.name,
            })),
          );
          setErrors({});
        } else {
          setShowNotify({
            show: true,
            title: "Error!",
            msg:
              response.data.msg ??
              "Failed to fetch issue types. Please try again later or contact gradious team.",
          });
        }
        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          const data = response.data.data ?? [];
          setBatches(
            data.map((item, index) => ({
              ...item,
              value: item.id,
              label: item.name,
            })),
          );
        } else {
          setShowNotify({
            show: true,
            title: "Error!",
            msg:
              response.data.msg ??
              "Failed to fetch batches. Please try again later or contact gradious team.",
          });
        }
      } catch (error) {
        setShowNotify({
          show: true,
          title: error.message.includes("403") ? "Warning!" : "Error!",
          msg: error.message.includes("403")
            ? "You have been logged-out due to inactivity. Login again."
            : (error.message ??
              "Something went wrong. Please try again later or contact gradious team."),
          isUnAuth: error.message.includes("403"),
        });
      } finally {
        setIsLoaded(false);
      }
    };
    // fetchBatchesAndTypes();
  }, [axios, setIsLoaded, setShowNotify, companyId]);

  const onChange = (name, value = "") => {
    if (name === "title") {
      setTitleCharCount(value.length);
      if (value.length === maxChar) return;
    }
    setErrors({ ...errors, [name]: validate(name, value) });
    setDetails({ ...details, [name]: value });
  };

  const onSelectIssueType = (event) => {
    setSelectedType(event.target);
    setErrors({ ...errors, type: validate("type", event.target.id) });
    setDetails({
      ...details,
      type: event.target.id,
      typeName: event.target.value,
    });
  };
  const onSelectBatch = (event) => {
    setSelectedBatch(event.target);
    setErrors({ ...errors, bid: validate("bid", event.target.id) });
    setDetails({ ...details, bid: event.target.id, bname: event.target.value });
  };

  const onDragOver = (event) => event.preventDefault();

  const onDrop = (event) => {
    const files = Array.from(event.dataTransfer.files);
    uploadFiles(files);
  };

  const uploadFiles = (files = []) => {
    if (files.length > 1) {
      setErrors({
        ...errors,
        attachment:
          "Multiple files are not supported in this format. Please upload a single ZIP file.",
      });
      return;
    }
    const isUploadableFormat = files.every((file) =>
      supportMimeTypes.includes(file.type),
    );
    if (!isUploadableFormat) {
      setErrors({
        ...errors,
        attachment: `Unsupported file type: ${
          files[0].type.split("/")[1]
        }. Allowed formats are: ${supportedFormat}`,
      });
      return;
    }
    setDetails({ ...details, attachment: files[0] });
    setErrors({ ...errors, attachment: "" });
  };

  const onUpload = (event) => {
    const files = Array.from(event.target.files);
    uploadFiles(files);
    event.target.value = "";
  };

  const onRemoveFile = () => {
    if (isEdit) setIsRemoved(true);
    setDetails({ ...details, attachment: null });
  };

  const onSumbitOrUpdate = async (event) => {
    event.preventDefault();
    let validationErrors = {};
    fields.forEach((name) => {
      const error = validate(name, details[name]);
      if (error && error.length > 0) {
        validationErrors[name] = error;
      }
    });
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    try {
      let attachment = details.attachment,
        path;
      if (attachment) {
        let imageName = attachment.name;
        path =
          !isEdit || (isEdit && isRemoved)
            ? `issues/${imageName?.substring(
                0,
                imageName.lastIndexOf("."),
              )}_${moment().toISOString()}${imageName?.substring(
                imageName.lastIndexOf("."),
              )}`
            : `issues/${imageName}`;
        if (!isEdit || (isEdit && isRemoved))
          await onUploadS3Object(
            path,
            attachment,
            imageName?.split(".").pop().toLowerCase(),
            "HOST",
            "PUT",
          );

        // details.attachment = path;
        details.attachmentSize = `${Math.floor(
          details.attachment.size / 125000,
        )}MB`;
        details.attachmentName = details.attachment.name;
      }
      const method = isEdit ? "put" : "post";
      const url = isEdit
        ? `node/learner/issue/${details.id}`
        : "node/learner/issue";
      if (isEdit) delete details.id;
      const response = await axios({
        method,
        url,
        data: {
          ...details,
          attachment: path,
          lpcid: Alert.testData.lpconfigid,
          request_type: constants.REQUEST_TYPE.EXTENSION_REQUEST,
        },
        headers: {
          "Content-Type": "application/json",
        },
      });
      // console.log("response:", response);

      if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        setIsSuccess(true);
        setToastMessage((prev) => ({
          message: response.data?.msg,
          icon: (
            <svg
              width="46"
              height="46"
              viewBox="0 0 46 46"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="3" y="3" width="40" height="40" rx="20" fill="#D1FADF" />
              <rect
                x="3"
                y="3"
                width="40"
                height="40"
                rx="20"
                stroke="#ECFDF3"
                stroke-width="6"
              />
              <g clip-path="url(#clip0_1393_14704)">
                <path
                  d="M20.5003 23L22.167 24.6667L25.917 20.9167M19.1118 16.1822C19.7817 16.1288 20.4176 15.8654 20.929 15.4295C22.1226 14.4124 23.8781 14.4124 25.0716 15.4295C25.5831 15.8654 26.219 16.1288 26.8889 16.1822C28.452 16.307 29.6933 17.5483 29.8181 19.1115C29.8715 19.7813 30.1349 20.4173 30.5708 20.9287C31.5879 22.1223 31.5879 23.8777 30.5708 25.0713C30.1349 25.5827 29.8715 26.2187 29.8181 26.8885C29.6933 28.4517 28.452 29.693 26.8889 29.8178C26.219 29.8712 25.5831 30.1346 25.0716 30.5705C23.8781 31.5876 22.1226 31.5876 20.929 30.5705C20.4176 30.1346 19.7817 29.8712 19.1118 29.8178C17.5486 29.693 16.3073 28.4517 16.1826 26.8885C16.1291 26.2187 15.8657 25.5827 15.4298 25.0713C14.4127 23.8777 14.4127 22.1223 15.4298 20.9287C15.8657 20.4173 16.1291 19.7813 16.1826 19.1115C16.3073 17.5483 17.5486 16.307 19.1118 16.1822Z"
                  stroke="#039855"
                  stroke-width="1.66667"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </g>
              <defs>
                <clipPath id="clip0_1393_14704">
                  <rect
                    width="20"
                    height="20"
                    fill="white"
                    transform="translate(13 13)"
                  />
                </clipPath>
              </defs>
            </svg>
          ),
        }));
        setToastOpen({
          vertical: "top",
          horizontal: "right",
          open: true,
          Transition: SlideTransition,
        });
      } else if (
        response.data.resultCode === constants.RESULT_STATUS.TECHNICAL_ERROR
      ) {
        setToastMessage((prev) => ({
          message: response.data?.msg,
          icon: (
            <svg
              width="56"
              height="56"
              fill="none"
              viewBox="0 0 56 56"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="4"
                y="4"
                width="48"
                height="48"
                rx="24"
                fill={"#FEF0C7"}
              />
              <rect
                x="4"
                y="4"
                rx="24"
                width="48"
                height="48"
                stroke-width="8"
                stroke="#FFFBFA"
              />
              <path
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M27.9998 24.0012V28.0012M27.9998 32.0012H28.0098M26.2898 18.8612L17.8198 33.0012C17.6451 33.3036 17.5527 33.6465 17.5518 33.9957C17.5508 34.3449 17.6413 34.6883 17.8142 34.9917C17.9871 35.2951 18.2365 35.5479 18.5375 35.725C18.8385 35.9021 19.1806 35.9973 19.5298 36.0012H36.4698C36.819 35.9973 37.1611 35.9021 37.4621 35.725C37.7631 35.5479 38.0124 35.2951 38.1854 34.9917C38.3583 34.6883 38.4488 34.3449 38.4478 33.9957C38.4468 33.6465 38.3544 33.3036 38.1798 33.0012L29.7098 18.8612C29.5315 18.5673 29.2805 18.3243 28.981 18.1557C28.6814 17.987 28.3435 17.8984 27.9998 17.8984C27.656 17.8984 27.3181 17.987 27.0186 18.1557C26.7191 18.3243 26.468 18.5673 26.2898 18.8612Z"
                stroke={"#D92D20"}
              />
            </svg>
          ),
        }));

        setToastOpen({
          vertical: "top",
          horizontal: "right",
          open: true,
          Transition: SlideTransition,
        });
      } else {
        setShowNotify({
          show: true,
          title: "Error!",
          msg:
            response.data.msg ??
            `Failed to ${
              isEdit ? "update" : "add"
            } issue. Please try again later or contact gradious team.`,
        });
      }
    } catch (error) {
      setShowNotify({
        show: true,
        title: error.message.includes("403") ? "Warning!" : "Error!",
        msg: error.message.includes("403")
          ? "You have been logged-out due to inactivity. Login again."
          : (error.message ??
            "Something went wrong. Please try again later or contact gradious team."),
        isUnAuth: error.message.includes("403"),
      });
    } finally {
      setIsLoaded(false);
      onCancel();
    }
  };

  const onCancel = (event) => {
    event?.preventDefault();
    setShowForm(false);
    setDetails(initialDetails);
    setIsSuccess(false);
    setSelectedBatch({});
    setSelectedType({});
    setErrors({});
  };

  // useEffect(() => {
  //   fetchLpConfigId();
  // }, []);

  useEffect(() => {
    if (getDataFromStorage("role") === constants.Roles.learner) {
      setDetails((prev) => ({
        ...prev,
        title: Alert.testData.testname ?? Alert.testData.libname,
        bid: localStorage.getItem("batchid"),
        type: "5",
        // lpcid: configid,
      }));
    }
  }, [Alert.testData, setDetails]);

  // // console.log("lpData:", lpData);/
  // console.log("lpData?.modules[0]?.data:", lpData?.modules[0]?.data ,Alert.testData);

  // const fetchLpConfigId = () => {
  //   const lpconfig = lpData?.modules[0]?.data.find((p) =>
  //     p.testid
  //       ? p.testid === Alert.testData.testid
  //       : p.libid === Alert.testData.libid
  //   );
  //   const lpconfigId = lpconfig?.lpconfigid;
  //   setConfigId(lpconfigId);
  //   // console.log("lpconfigId", lpconfigId);
  // };

  // console.log("Alert.testData.testid",Alert.testData.testid);;
  // console.log("Alert.testData.libid",Alert.testData.libid);

  return (
    <Fragment>
      {/* {!isSuccess ? ( */}
      <form className="issueFormContainer">
        <div className="issueFormFields">
          <InputField
            name="title"
            label="Test Name"
            value={
              getDataFromStorage("role") === constants.Roles.learner
                ? (Alert.testData.testname ?? Alert.testData.libname)
                : details.title
            }
            disabled={true}
            destructive={errors["title"] && errors["title"].length}
          />

          <Textarea
            label="Reason"
            placeholder="Explain your reason in detail here"
            name="description"
            value={details.description}
            onChange={(event) =>
              onChange(event.target.name, event.target.value)
            }
            disabled={isDisabled}
            hintText={errors["description"]}
            destructive={!!errors["description"]}
          />
        </div>
        {getDataFromStorage("role") === constants.Roles.learner ? (
          <div className="issueFormBtnSec">
            <Button
              size="lg"
              hierarchy={{ type: "secondaryGrey", buttonText: "Cancel" }}
              onClick={onCancel}
            />
            <Button
              size="lg"
              hierarchy={{
                type: "primary",
                buttonText: isEdit ? "Update" : "Submit",
              }}
              onClick={onSumbitOrUpdate}
            />
          </div>
        ) : (
          <Button
            size="lg"
            hierarchy={{ type: "primary", buttonText: "Extend" }}
            onClick={(e) => {
              e.preventDefault();
              const extensionDate = moment(new Date()).format(
                "YYYY-MM-DD HH:mm:ss",
              );
              localStorage.setItem("extensionDate", extensionDate);
              Alert.setExtensionDate(extensionDate);
              setShowForm(false);
              setExtentPopUp(true);
            }}
          />
        )}
      </form>
      {/* ) : (
        <div className="issueSuccessContainer">
          <div className="issueSuccessIcon">
            <svg
              width="144"
              height="150"
              viewBox="0 0 144 150"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M132 69.2858V75.0358C131.993 88.5134 127.803 101.627 120.056 112.422C112.309 123.217 101.42 131.114 89.0121 134.935C76.6046 138.757 63.3435 138.298 51.2068 133.627C39.0701 128.956 28.7079 120.324 21.6658 109.017C14.6236 97.711 11.2787 84.3362 12.1301 70.8877C12.9814 57.4393 17.9832 44.6378 26.3897 34.3925C34.7961 24.1471 46.1567 17.0069 58.7771 14.0367C71.3975 11.0665 84.6016 12.4254 96.42 17.9108M132 25L72 87.5625L54 68.8125"
                stroke="#12B76A"
                strokeWidth="8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <div className="issueSuccessText">
              New Issue successfully {isEdit ? "updated" : "submitted"}
            </div>
          </div>
          <Button
            size="lg"
            hierarchy={{ type: "primary", buttonText: "Ok" }}
            onClick={onCancel}
          />
        </div>
      )} */}
    </Fragment>
  );
};

export default ExtentionRequestForm;
